"use client";

import { useQuery } from "@tanstack/react-query";

import { fetchViabilities } from "@/services/vialibity";

import { queryKeys } from "./query-key";
import { ViabilityFilter } from "@/types";

interface UseViabilitiesProps extends ViabilityFilter {
  hasPaidPlan?: boolean;
}

export const useViabilities = ({ hasPaidPlan, id }: UseViabilitiesProps) => {
  return useQuery({
    queryKey: queryKeys.viabilities({ id }),
    queryFn: () => fetchViabilities({ id }),
    enabled: hasPaidPlan,
  });
};
